import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { MdEmail, MdLocationOn, MdCall } from 'react-icons/md'

// Styles
import styles from './styles.module.css'

import Responsive from '../../util/Responsive'

import iconReclamacao from './icon-reclamacao.png'
import colorLogo from '../../../assets/images/logo-solmar.png'
import { getServicesList } from '../../state/services/selectors'
import { getEmailsList, getAddressesList, getPhonesList } from '../../state/contacts/selectors'

const Footer = ({
                  logo = colorLogo,
                  background,
                  home,
                  fixed = false,
                  servicesList = [],
                  phones = [],
                  emails = [],
                  addresses = [],
                  menus = [
                    {
                      title: 'Sobre Nós',
                      path: '/',
      
                      sections: [
                        {
                          title: 'Quem Somos',
                          path: '/quem-somos/',
                        },
                        {
                          title: 'Serviços',
                          path: '/servicos/',
                        },
                        {
                          title: 'Produtos',
                          path: '/produtos/',
                        },
                      ],
                    },
                    {
                      title: 'Serviços',
                      path: '/servicos/',
      
                      sections: servicesList.map(({ name, id }) => ({
                        title: name,
                        path: `/servicos/${ id }`,
                      })),
                    },
                    {
                      title: 'Contactos',
                      path: '/contactos/',
                      sections: [
                        ...phones.map(({ phone }) => ({
                          title: (
                            <div>
                              <MdCall/>{ ' ' + phone }
                            </div>
                          ),
                          path: '/contactos',
                        })),
                        ...emails.map(({ email }) => ({
                          title: (
                            <div>
                              <MdEmail/>{ ' ' + email }
                            </div>
                          ),
                          path: '/contactos',
                        })),
                        ...addresses.map(({ address }) => ({
                          title: (
                            <div>
                              <MdLocationOn/>{ ' ' + address }
                            </div>
                          ),
                          path: '/contactos',
                        })),
                      ],
                    },
                  ],
                }) => {
  return (
    <div>
      <Responsive name="desktop" className={ `${ styles.main } ${ fixed ? styles.fixed : '' }` }>
        <div
          className={ `${ styles.top } ${ home ? styles.home : '' } ${ background ? styles.withTopBackground : styles.noBackground }` }>
        </div>
        <div className={ `${ styles.middle } ${ background ? styles.withBackground : styles.noBackground }` }>
          <div className={ styles.middleWrapper }>
            <div className={ styles.logo }>
              <img src={ logo } className={ `${ background ? styles.withBackground : styles.noBackground }` }/>
            </div>
            <div className={ styles.menus }>
              {
                menus.map((menu, key) => (
                  <div className={ `${ styles.menu } ${ background ? styles.whiteMenu : '' }` }
                       key={ `footer-menu-${ key }` }>
                    <Link to={ menu.path }>
                      { menu.title }
                    </Link>
                    <div className={ styles.sections }>
                      {
                        menu.sections && menu.sections.map(
                          (section, key) => (
                            <Link key={ `section-${ key }` } to={ section.path }>
                              { section.title }
                            </Link>
                          ))
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
          <div className={ styles.reclamacao }>
            <a href={ 'https://www.livroreclamacoes.pt/inicio' } target={ '_blank' }>
              <img src={ iconReclamacao }/>
            </a>
          </div>
        </div>
      </Responsive>
      <Responsive name="phone" className={ styles.phone }>
        <div className={ styles.miniFooter }>
          <img src={ logo }/>
        </div>
        <div className={ styles.reclamacao }>
          <a href={ 'https://www.livroreclamacoes.pt/inicio' } target={ '_blank' }>
            <img src={ iconReclamacao }/>
          </a>
        </div>
      </Responsive>
      <div className={ styles.credits }>
        <div>
          Desenvolvido por: <a href="mailto:fpsousa91@gmail.com">Filipe Sousa</a>
        </div>
        <div>
          Credits: <a href="http://www.freepik.com">Banners/Vectors by Freepik</a>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = () => {
  return (state) => ({
    servicesList: getServicesList(state),
    emails: getEmailsList(state),
    addresses: getAddressesList(state),
    phones: getPhonesList(state),
  })
}

export default connect(mapStateToProps)(Footer)
